import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Using custom error logging system (see /backend/routes/error-logs.js)

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
